class EventEmitter {

	constructor() {
		this.subscribers = {};
		this.callbackLater = {};
	}

	subscribe(eventName, callback) {
		this.subscribers[eventName] = callback;
		const dataCallbackLater = this.callbackLater[eventName];
		if (dataCallbackLater) {
			callback(dataCallbackLater);
			delete this.callbackLater[eventName];
		}
	}

	unsubscribe(eventName) {
		delete this.subscribers[eventName];
	}

	emmit(eventName, data) {
		let callback = this.subscribers[eventName];
		if (callback) {
			callback(data);
		} else {
			this.callbackLater[eventName] = data;
		}
	}
}

const eventEmitter = new EventEmitter();
export default eventEmitter;